import React from 'react';
import { useSelector } from 'react-redux';
import { Container } from 'common/components';
import { photoUrlBase } from 'constants/common';
import { Typography } from 'fronton-react';
import { WindowTypes, selectWindowType } from 'store/pageStore';
import { checkScreenType } from 'utils';
import { bannerContainer } from './styles';

export const Banner = () => {
	const currentWindowType = useSelector(selectWindowType);
	const isMobile = checkScreenType(currentWindowType, WindowTypes.mobile);
	return (
		<Container>
			<div className={`${bannerContainer}`}>
				<div className="banner-container__text-block">
					<Typography
						variant={isMobile ? 'h1' : 'display'}
						className="banner-container__header"
						as="h1"
					>
						Колеровка онлайн
					</Typography>
					<Typography variant={isMobile ? 'm' : 'l'} size="body_long">
						Теперь вы можете придать краске индивидуальный оттенок, не приезжая в
						магазин. Закажите колеровку краски, лака или штукатурки с доставкой на дом.
						Колеровка входит в стоимость товара при заказе на сайте. Мы всегда поможем
						сделать ремонт — даже когда нет возможности выйти из дома.
					</Typography>
				</div>
				<div className="banner-container__img">
					<img
						src={`${photoUrlBase}/NjYHAtU-fUaHJnUBTvhp2g/services-platform-landing-kolerovka-main.png`}
					/>
				</div>
			</div>
		</Container>
	);
};
